// hooks/useEvent.js
import { useState, useEffect, useCallback } from 'react';
import axiosClient from '../api/axiosClient';

const useEvent = (eventId, user) => {
  const [event, setEvent] = useState(null);
  const [isOwner, setIsOwner] = useState(false);
  const [loadingEvent, setLoadingEvent] = useState(true);
  const [error, setError] = useState(null);

  // 1) Función para obtener el evento (expuesta para re-fetch)
  const fetchEvent = useCallback(async () => {
    setLoadingEvent(true);
    setError(null);
    try {
      const response = await axiosClient.get(`/api/events/${eventId}`);
      if (response.data.success) {
        setEvent(response.data.event);
        setIsOwner(!!(user && response.data.event.owner.id === user.id));
      } else {
        setError(response.data.message || 'No se pudo obtener el evento.');
      }
    } catch (err) {
      console.error('Error al obtener el evento:', err);
      setError('Error al obtener el evento.');
    } finally {
      setLoadingEvent(false);
    }
  }, [eventId, user]);

  // 2) Cargar evento al montar y cada vez que cambian eventId o user
  useEffect(() => {
    if (eventId) fetchEvent();
  }, [eventId, user, fetchEvent]);

  return { event, isOwner, loadingEvent, error, setEvent, fetchEvent };

};

export default useEvent;
